import { axiosInstance } from "@follosoft/react-components";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
 * Undoes an off-platform payment method the customer picked by mistake.
 *
 * The API allows this only inside a short window after the choice, and only once
 * per contract, so treat a rejection as a final answer rather than something to
 * retry — `meta.payment_method_change` on the refetched contract says which of
 * the two ran out.
 */
export function useCancelOfflineSubscription() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      contractId,
      subscriptionId,
    }: {
      contractId: number | string;
      subscriptionId: number | string;
    }) => {
      return axiosInstance().post(
        `/folloportal/contracts/${contractId}/offline-payment/${subscriptionId}/cancel`
      );
    },
    onSuccess: () => {
      // The contract carries the agreement, the payment-method window and the
      // totals — cancelling gives back the promotion rebate the subscription
      // had applied, so the prices move too.
      queryClient.invalidateQueries({ queryKey: ["contract"] });
      queryClient.invalidateQueries({ queryKey: ["available-payment-plans"] });
      queryClient.invalidateQueries({ queryKey: ["online-payment-options"] });
    },
  });
}
